export function openTextFile(cb: (txt: string) => void, accept?: string) {
  const el = document.createElement('input');
  el.type = 'file';
  if (accept) {
    el.accept = accept;
  }

  el.addEventListener('change', () => {
    const filename = el.files?.[0];
    if (!filename) {
      return;
    }

    const reader = new FileReader();
    reader.readAsText(filename, 'UTF-8');
    reader.addEventListener('load', () => {
      if (typeof reader.result === 'string') {
        cb(reader.result);
      }
    });
  });

  el.click();
}
